export const configes = {
  domainName: "franceWeb",
  domainURL: "france.com",
  domainId: "67459da72c57f4142be0cd6e",
};